// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";

function VpaIdPaymentInput(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userVpaId);
  var setVpaId = match$1[1];
  var vpaId = match$1[0];
  var vpaIdRef = React.useRef(null);
  var changeVpaId = function (ev) {
    var val = ev.target.value;
    setVpaId(function (prev) {
          return {
                  value: val,
                  isValid: Utils$OrcaPaymentPage.isVpaIdValid(val),
                  errorString: Core__Option.getOr(Utils$OrcaPaymentPage.isVpaIdValid(val), false) ? "" : prev.errorString
                };
        });
  };
  var onBlur = function (ev) {
    var val = ev.target.value;
    var isValid = Utils$OrcaPaymentPage.isVpaIdValid(val);
    var errorString = isValid !== undefined && !isValid ? localeString.vpaIdInvalidText : "";
    setVpaId(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.errorString = errorString;
          newrecord.isValid = isValid;
          return newrecord;
        });
  };
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit && vpaId.value === "") {
            return setVpaId(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.errorString = localeString.vpaIdEmptyText;
                        return newrecord;
                      });
          }
          
        }), [vpaId]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement(PaymentField$OrcaPaymentPage.make, {
              setValue: setVpaId,
              value: vpaId,
              onChange: changeVpaId,
              onBlur: onBlur,
              fieldName: localeString.vpaIdLabel,
              name: "vpaId",
              type_: "text",
              placeholder: "Eg: johndoe@upi",
              inputRef: vpaIdRef
            });
}

var make = VpaIdPaymentInput;

export {
  make ,
}
/* react Not a pure module */
